import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParam = (key: string) => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  return useMemo(() => search.get(key) || undefined, [location]);
};
